import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import I18n from 'i18n-react';

import './FlightInfoResume.css';

const propTypes = {
  principalContact: PropTypes.string.isRequired,
  pnrNumber: PropTypes.string.isRequired,
  originAirportCode: PropTypes.string.isRequired,
  originAirportName: PropTypes.string.isRequired,
  destinationAirportCode: PropTypes.string.isRequired,
  destinationAirportName: PropTypes.string.isRequired,
  isCancellationMessageEnabled: PropTypes.bool,
  isCallcenterEnabled: PropTypes.bool
};

const defaultProps = {
  isCancellationMessageEnabled: false
};

class FlightInfoResume extends React.Component {  
  render() {
    return (
      <Row id="componentFlightInfoResume" className="FlightInfoResume">
        <Col id="lblGreetingsPrincipalContact" xs={12} className="FlightInfoResume__greetings">
          {`${I18n.translate('components.resume.greetings')}, ${this.props.principalContact}.`}
        </Col>
        <Col xs={12} className="FlightInfoResume__subtitle1">
          {I18n.translate('components.resume.subtitle1-init')}
          <span>{I18n.translate('components.resume.subtitle1-end')}</span>
        </Col>
        <Col xs={12} className="FlightInfoResume__flightInfo">
          <Row>
            <Col xs={12} mdOffset={2} md={8} className="FlightInfoResume__subtitle2">
              {I18n.translate('components.resume.subtitle2')}
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="FlightInfoResume__codeAndIconLine">
              <span id="lblOriginAirportCode" className="FlightInfoResume__airportCode">
                {this.props.originAirportCode}
                <span id="lblOriginAirportName" className="FlightInfoResume__airportName">
                  {this.props.originAirportName}
                </span>
              </span>
              <span className="FlightInfoResume_airportCodeSeparator" />
              <span className="FlightInfoResume__separatorLine" />
              <span className="FlightInfoResume_airportCodeSeparator" />
              <span className="FlightInfoResume__airplaneIconDiv">
                <span className="FlightInfoResume__airplaneIcon" />
              </span>
              <span className="FlightInfoResume_airportCodeSeparator" />
              <span className="FlightInfoResume__separatorLine" />
              <span className="FlightInfoResume_airportCodeSeparator" />
              <span id="lblDestinationAirportCode" className="FlightInfoResume__airportCode">
                {this.props.destinationAirportCode}
                <span id="lblDestinationAirportName" className="FlightInfoResume__airportName">
                  {this.props.destinationAirportName}
                </span>
              </span>
            </Col>
          </Row>
          <Row className="FlightInfoResume__pnr">{this.renderPNR()}</Row>
          {this.renderCancellationMessage()}
        </Col>
      </Row>
    );
  }

  renderCancellationMessage() {    
    if (this.props.isCancellationMessageEnabled) {
      const telCapital = I18n.translate('components.loginCallcenter.tudoAzulTel');
      const telGeral = I18n.translate('components.loginCallcenter.tudoAzulTelGlobal');
      return (
        <Row>
          <Col xs={12} mdOffset={2} md={8} className="FlightInfoResume__cancellationMessage">
            {I18n.translate('components.resume.cancellationMessage',{telCapital:telCapital,telGeral:telGeral})}
          </Col>
        </Row>
      );
    }
  }

  renderPNR() {
    if (this.props.isCallcenterEnabled) {
      return (
        <Row>
          <Col xs={12} mdOffset={1} md={10} className="FlightInfoResume__pnrBox">
            {`${I18n.translate('components.resume.pnrNumber')}: `}
            <span id="lblPnrNumber">{this.props.pnrNumber}</span>
          </Col>
        </Row>
      );
    } else {
      return (
        <Row>
          <Col xs={12} mdOffset={1} md={10} className="FlightInfoResume__pnrBox">
            {`${I18n.translate('components.resume.paymentPendent')}`}
          </Col>
        </Row>
      );
    }
  }
}

FlightInfoResume.propTypes = propTypes;
FlightInfoResume.defaultProps = defaultProps;
export default FlightInfoResume;



// WEBPACK FOOTER //
// ./src/components/bookingResume/flightInfoResume/FlightInfoResume.jsx